import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import styles from "./canalesCarta.module.css";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import hbomax from "../../assets/img/Cartetelera/thumbnail/hbomax.png";
import foxsports from "../../assets/img/Cartetelera/thumbnail/foxsports.png";
import universal from "../../assets/img/Cartetelera/thumbnail/universalplus.png";
import izzi from "../../assets/img/Cartetelera/thumbnail/Afizzionados.png";
import goldenpremier from "../../assets/img/Cartetelera/thumbnail/golden.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import flecha from "../../assets/img/Iconos/flechaAbajo.svg";
import { Collapse, Form, Row } from "react-bootstrap";
import { Canal } from "../../Commons/Services/ConsultarCartelera";
import juici from "../../assets/img/Cartetelera/thumbnail/juicy.jpg";
import venus from "../../assets/img/Cartetelera/thumbnail/venus.jpg";
import hustler_tv from "../../assets/img/Cartetelera/thumbnail/hustler-desktop.jpg";
import secrets from "../../assets/img/Cartetelera/thumbnail/secrets-desktop.jpg";
import tv_hot from "../../assets/img/Cartetelera/thumbnail/tvhot-desktop.jpg";
import tv_hothd from "../../assets/img/Cartetelera/thumbnail/tvhot-desktop-hd.jpg";
import ve_extremo from "../../assets/img/Cartetelera/thumbnail/vextremo-desktop.jpg";
import playboy from "../../assets/img/Cartetelera/thumbnail/playboy-desktop.jpg";
import disneyplus_min from "../../assets/img/Cartetelera/thumbnail/disneyplus.png";
import starplus_min from "../../assets/img/Cartetelera/thumbnail/starplus.png";
import comboplus_min from "../../assets/img/Cartetelera/thumbnail/comboplus.png";
import vix from "../../assets/img/Cartetelera/thumbnail/vix.png";
import Loading from "../../General/Loading";
import { BsX } from "react-icons/bs";
import ConfirmMessage from "../../General/ConfirmMessage";
import {
  builtEnviarOTTEntrada,
  Complement,
  EnviarOTT,
  EnviarOTT_Entrada,
  EnviarOTT_Respuesta,
} from "../../Commons/Services/EnviarOTT";
import { ConsultaWS } from "../../Commons/ServiciosBase";
import {
  builtReenviarOTTEntrada,
  ComplementReenviar,
  _reenviarOTT,
  reenviarOTT_Entrada,
  reenviarOTT_Respuesta,
} from "../../Commons/Services/ReenviarOTT";
import {
  builtGestionarSSComprarServicios_Entrada,
  builtGestionarSSComprarServiciosRequestEBM,
  builtInstance,
  builtListOfInstances,
  builtListOfProducts,
  builtProduct,
  builtServiceInfoRequest,
  GestionarSSComprarServicios_Entrada,
  GestionarSSComprarServicios_Parametros,
  GestionarSSComprarServicios_Respuesta,
  GestionarSSComprarServiciosRequestEBM,
  Instance,
  ListOfInstances,
  ListOfProducts,
  Product,
  ServiceInfoRequest,
} from "../../Commons/Services/GestionarSSComprarServiciosRest";

const { REACT_APP_LOCAL } = process.env;

const CanalesCarta = (props: any) => {
  const { arrayCanal2, indice2, muestra2, origen2, nombreorigen }: any = {
    ...props,
  };

  const [numUno, setNumUno] = useState("");
  const [numDos, setNumDos] = useState("");
  const [numTres, setNumTres] = useState("");
  const [numCuatro, setNumCuatro] = useState("");

  const [selectedChannel, setSelectedChannel] = useState<Canal | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const handleClose = () => setShowModal(false);
  const [code, setCode] = useState(["", "", "", ""]);
  const [collapse, setCollapse] = useState(false);
  const [muestraModal, setMuestraModal] = useState<any>([]);
  const muestraCollapse = () => {
    setCollapse(!collapse);
  };
  const [phone, setPhone] = useState("");
  const [mail, setMail] = useState("");
  const [nombreOTT, setNombreOTT] = useState("");
  const [nombreOTTCRM, setNombreOTTCRM] = useState("");
  const [loading, isLoading] = useState(false);
  const [status, setStatus] = useState("OK");
  const [message, setMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const tipoPlan = sessionStorage.getItem("tipoCliente");

  const setFocusById = (p_elementid: string) => {
    const element = document.getElementById(p_elementid);
    if (element) {
      element.focus();
    } else {
      console.warn(`Elemento con id ${p_elementid} no encontrado`);
    }
  };

  const handleChange2 = (index: number, value: string) => {
    console.log(value);
    if (value.length === 1) {
      if (/^[0-9]?$/.test(value)) {
        if (index === 1) {
          setNumUno(value);
          setFocusById("inputdos");
        } else if (index === 2) {
          setNumDos(value);
          setFocusById("inputtres");
        } else if (index === 3) {
          setNumTres(value);
          setFocusById("inputcuatro");
        } else if (index === 4) {
          setNumCuatro(value);
          setFocusById("buttonToSent");
        }
      }
    }
  };

  interface Estado {
    id: number;
    muestra: boolean;
  }
  const settingsSmall = {
    arrows: true,
    // slidesToShow: cSlidesShow < 4 ? cSlidesShow : 4,
    slidesToShow: 4,
    slidesToScroll: 2,
    infinite: true,
    emulateTouch: true,
    dots: true,
    speed: 1000,
    autoplay: true,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: true,
          slidesToShow: 3,
          slidesToScroll: 2,
          infinite: true,
          emulateTouch: true,
          dots: true,
          speed: 1000,
          autoplay: true,
        },
      },
      {
        breakpoint: 991,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          emulateTouch: true,
          dots: true,
          speed: 1000,
          autoplay: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          emulateTouch: true,
          dots: true,
          speed: 1000,
          autoplay: true,
        },
      },
    ],
  };

  const verificaskyplus = sessionStorage.getItem("PaqueteSky+");
  let preciovix = "";

  if (verificaskyplus != undefined && verificaskyplus == "SKY+ Premium") {
    preciovix = "79";
  } else if (verificaskyplus != undefined && verificaskyplus == "SKY+ Basico") {
    preciovix = "99";
  } else {
    preciovix = "99";
  }

  const precios = [
    { titulo: "Max", leyenda: "", precio: "199" },
    sessionStorage.getItem("tipoCliente") === "POS"
      ? { titulo: "Universal+", leyenda: "", precio: "159" }
      : { titulo: "Universal+", leyenda: "", precio: "179" },
    { titulo: "Fox Sports Premium", leyenda: "", precio: "139" },
    { titulo: "Disney+", leyenda: "", precio: "159" },
    { titulo: "Star+", leyenda: "", precio: "199" },
    {
      titulo: "ViX Premium",
      leyenda: "Por tiempo limitado",
      precio: preciovix,
    },
  ];

  const handleChange = (index: number, value: string) => {
    if (value.length === 1) {
      const newCode = [...code];
      newCode[index] = value;
      setCode(newCode);
    }
  };

  const getImages = (titulo: string, source: string) => {
    if (titulo.includes("izzi") || titulo.includes("IZZI")) {
      return izzi;
    } else if (titulo.includes("disney") || titulo.includes("Disney")) {
      return disneyplus_min;
    } else if (titulo.includes("star") || titulo.includes("Star")) {
      return starplus_min;
    } else if (titulo.includes("combo") || titulo.includes("Combo")) {
      return comboplus_min;
    } else if (titulo.toLocaleLowerCase().includes("vix")) {
      return vix;
    } else if (
      titulo.includes("HBO") ||
      (titulo.includes("hbo") && titulo.includes("MAX")) ||
      titulo.includes("max") ||
      titulo.includes("Max")
    ) {
      return hbomax;
    } else if (titulo.includes("fox sports") || titulo.includes("Fox Sports")) {
      return foxsports;
    } else if (titulo.includes("universal") || titulo.includes("Universal")) {
      return universal;
    } else if (titulo.includes("Golden") || titulo.includes("Golden Premier")) {
      return goldenpremier;
    } else if (
      titulo.includes("juicy") ||
      titulo.includes("Juicy") ||
      titulo.includes("JUICY")
    ) {
      return juici;
    } else if (
      titulo.includes("secrets") ||
      titulo.includes("Secrets") ||
      titulo.includes("SECRETS")
    ) {
      return secrets;
    } else if (
      titulo.includes("venus") ||
      titulo.includes("Venus") ||
      titulo.includes("VENUS")
    ) {
      return venus;
    } else if (
      titulo.includes("hustler") ||
      titulo.includes("Hustler") ||
      titulo.includes("HUSTLER") ||
      titulo.includes("Adultos Comercial canal 928")
    ) {
      //
      return hustler_tv;
    } else if (
      titulo.includes("HOT") ||
      titulo.includes("Hot") ||
      titulo.includes("hot")
    ) {
      if (
        titulo.includes("hd") ||
        titulo.includes("Hd") ||
        titulo.includes("HD")
      ) {
        return tv_hothd;
      } else {
        return tv_hot;
      }
    } else if (
      titulo.includes("Vextremo") ||
      titulo.includes("vextremo") ||
      titulo.includes("VEXTREMO")
    ) {
      return ve_extremo;
    } else if (
      titulo.includes("playboy") ||
      titulo.includes("Playboy") ||
      titulo.includes("PLAYBOY")
    ) {
      return playboy;
    } else {
      return source;
    }
  };

  const handleShow = () => {
    setShowModal(true);
  };

  const enviarOTT = async (item: any) => {
    isLoading(true);
    const complement: Complement = {
      nombreComercial: item.nombre,
      nombreSiebel: item.nombreProductoCRM,
    };
    const complements: Complement[] = [complement];
    const enviarOTTsRequestEBM: EnviarOTT_Entrada = builtEnviarOTTEntrada(
      sessionStorage.getItem("cuenta") ?? "",
      sessionStorage.getItem("PostalCodeCP") ?? "",
      complements
    );

    let enviarOTTParametros = EnviarOTT(enviarOTTsRequestEBM);

    let enviarOTTRespuesta: EnviarOTT_Respuesta =
      await ConsultaWS(enviarOTTParametros);

    if (enviarOTTRespuesta.code === "0") {
      setPhone(enviarOTTRespuesta.datos.phone_number);
      setMail(enviarOTTRespuesta.datos.email);
      isLoading(false);
    } else {
      console.error("Error en la respuesta:", enviarOTTRespuesta);
      isLoading(false);
    }
  };

  const reenviarOTT = async () => {
    isLoading(true);
    const complement: ComplementReenviar = {
      nombreComercial: nombreOTT,
      nombreSiebel: nombreOTTCRM,
    };
    const complements: ComplementReenviar[] = [complement];
    const reenviarOTTsRequestEBM: reenviarOTT_Entrada = builtReenviarOTTEntrada(
      sessionStorage.getItem("cuenta") ?? "",
      sessionStorage.getItem("PostalCodeCP") ?? "",
      complements
    );

    let reenviarOTTParametros = _reenviarOTT(reenviarOTTsRequestEBM);

    let reenviarOTTRespuesta: reenviarOTT_Respuesta = await ConsultaWS(
      reenviarOTTParametros
    );

    if (reenviarOTTRespuesta.code === "0") {
      isLoading(false);
    } else {
      console.error("Error en la respuesta:", reenviarOTTRespuesta);
      isLoading(false);
    }
  };

  const verificarOTT = async () => {
    isLoading(true);
    try {
      const response = await fetch(REACT_APP_LOCAL + `/izzi/token/verificar`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          numberContract: sessionStorage.getItem("cuenta"),
          token: numUno + numDos + numTres + numCuatro,
          zipCode: sessionStorage.getItem("PostalCodeCP"),
          purchaseInfo: {
            GestionarSSComprarServiciosRequestEBM: {
              ServiceInfoRequest: {
                Proceso: "Servicio Adicional",
                Cuenta: sessionStorage.getItem("cuenta"),
                Categoria: "Service OTT",
                Grupo: "Venta a suscriptor",
                Tipo: "Solicitud de Aprovisionamiento",
                Origen: "Web",
                ListOfInstances: {
                  Instance: [
                    {
                      AssetNumber: sessionStorage.getItem("assetNumber"),
                      SecondAssetNumber:
                        sessionStorage.getItem("SecondAssetNumber"),
                      ListOfProducts: {
                        Product: [
                          {
                            Name: nombreOTTCRM,
                            Action: "Add",
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            },
          },
        }),
      });

      const data = await response.json();
      if (response.ok && data.message === "Token correcto") {
        console.log(data.purchaseInfo.EBMHeaderResponse.ErrorNegocio.Estado);
        isLoading(false);
        setShowModal(false);
        manejaToast("OK", "Contratación Exitosa");
        setNumUno("");
        setNumDos("");
        setNumTres("");
        setNumCuatro("");
      } else {
        console.error("Error en la respuesta:", data);
        isLoading(false);
        setShowModal(false);
        setShowErrorModal(true);
      }
    } catch (error) {
      console.error("Error en la petición:", error);
      isLoading(false);
      setShowModal(false);
    }

    if (nombreOTTCRM === "Servicio OTT Disney+ Premium DTH") {
      doGestionarSSComprarServicios();
    }
  };

  const doGestionarSSComprarServicios = async () => {
    let product1: Product = builtProduct("", "");
    let product2: Product = builtProduct("", "");
    let listOfProducts: ListOfProducts = builtListOfProducts([]);

    if (nombreOTTCRM === "Servicio OTT Disney+ Premium DTH") {
      product1 = builtProduct(nombreOTTCRM, "Add");
      product2 = builtProduct(
        "Servicio OTT Disney+ Estandar DTH",
        "Disconnect"
      );
    }

    listOfProducts = builtListOfProducts([product1, product2]);

    const instance: Instance = builtInstance(
      sessionStorage.getItem("assetNumber") ?? "",
      sessionStorage.getItem("SecondAssetNumber") ?? "",
      listOfProducts
    );
    const listOfInstances: ListOfInstances = builtListOfInstances([instance]);
    const serviceInfoRequest: ServiceInfoRequest = builtServiceInfoRequest(
      "Servicio Adicional",
      `${sessionStorage.getItem("cuenta")}`,
      "Service OTT",
      "Venta a suscriptor",
      "Solicitud de Aprovisionamiento",
      "Web",
      listOfInstances
    );

    const gestionarSSComprarServiciosRequestEBM: GestionarSSComprarServiciosRequestEBM =
      builtGestionarSSComprarServiciosRequestEBM(serviceInfoRequest);
    const gestionarSSComprarServiciosEntrada: GestionarSSComprarServicios_Entrada =
      builtGestionarSSComprarServicios_Entrada(
        gestionarSSComprarServiciosRequestEBM
      );

    let GestionarSSComprarServiciosParametros =
      GestionarSSComprarServicios_Parametros(
        gestionarSSComprarServiciosEntrada
      );

    let GestionarSSComprarServiciosRespuesta: GestionarSSComprarServicios_Respuesta =
      await ConsultaWS(GestionarSSComprarServiciosParametros);
    //----------------------------------------------------------------------------------------------------------------------------

    if (
      GestionarSSComprarServiciosRespuesta
        .GestionarSSComprarServiciosResponseEBM.ServiceInfoResponse.NumeroSS &&
      GestionarSSComprarServiciosRespuesta
        .GestionarSSComprarServiciosResponseEBM.ServiceInfoResponse.NumeroSS !=
        null &&
      GestionarSSComprarServiciosRespuesta
        .GestionarSSComprarServiciosResponseEBM.ServiceInfoResponse.NumeroSS !=
        ""
    ) {
    } else {
      console.error(GestionarSSComprarServiciosRespuesta);
    }
  };

  const manejaToast = (status: string, mensaje: string) => {
    setStatus(status);
    setMessage(mensaje);
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 3000);
  };

  const formatoOTT = (item: any) => {
    if (
      item.nombreProductoCRM === "Servicio OTT Disney+ Estandar DTH" ||
      item.nombreProductoCRM === "Servicio OTT Disney+ Premium DTH" ||
      item.nombreProductoCRM === "Servicio OTT VIX"
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      <div id="big" className="d-none d-xl-block d-lg-block ">
        <Container className={styles.contenedor} fluid>
          <div className={styles["confirmMessage"]}>
            <ConfirmMessage
              status={status}
              message={message}
              showAlert={showAlert}
            />
          </div>
          <p className={styles["disfruta_tex"]}>
            <b>Disfruta de las opciones que tenemos para ti con cargo extra.</b>
          </p>

          {arrayCanal2.length >= 4 ? (
            <Row className={props.CarteleraSkyPlus ? "row-cols-lg-4" : ""}>
              {arrayCanal2.map((itemCanal: Canal, index: number) => (
                <Col key={index} className="pb-5">
                  <Card
                    style={{ width: "18rem", padding: "20px 15px 10px 15px" }}
                  >
                    <img
                      src={getImages(itemCanal.nombre, itemCanal.imagen)}
                      className={styles.imagen}
                    />
                    <Card.Body className={styles.cardBody}>
                      <Card.Title className={styles.tituloazul}>
                        {itemCanal.nombre}
                      </Card.Title>
                      <Card.Text className={styles.price}>
                        {(() => {
                          let td = [];
                          let promo = false;

                          for (let i = 0; i < precios.length; i++) {
                            let item = precios[i];

                            if (tipoPlan === "POS") {
                              if (
                                item.titulo === itemCanal.nombre &&
                                item.titulo
                              ) {
                                promo = true;
                                td.push(
                                  <>
                                    <span className={styles.tituloazulleyenda}>
                                      {item.leyenda}
                                    </span>{" "}
                                    <span className={styles.tituloazulprecio}>
                                      ${itemCanal.precio} /mes
                                    </span>
                                  </>
                                );
                                return td;
                              }
                            } else {
                              if (
                                item.titulo === itemCanal.nombre &&
                                item.titulo
                              ) {
                                promo = true;
                                td.push(
                                  <>
                                    <span className={styles.tituloazulleyenda}>
                                      {item.leyenda}
                                    </span>{" "}
                                    {item.titulo !== "Universal+" ? (
                                      <span className={styles.tituloazulprecio}>
                                        ${itemCanal.precio} /mes
                                      </span>
                                    ) : (
                                      <>
                                        <span style={{ color: "white" }}>
                                          {" "}
                                          ...{" "}
                                        </span>
                                      </>
                                    )}
                                  </>
                                );
                                return td;
                              }
                            }
                          }

                          if (!promo) {
                            td.push(
                              <>
                                <span style={{ color: "white" }}> ... </span>
                              </>
                            );
                          }
                          return td;
                        })()}
                      </Card.Text>
                      <Card.Text className={styles.price}>
                        {(() => {
                          let td = [];
                          let promo = false;
                          for (let i = 0; i < precios.length; i++) {
                            let item = precios[i];

                            if (
                              item.titulo === itemCanal.nombre &&
                              item.titulo
                            ) {
                              promo = true;
                              td.push(
                                <>
                                  <span className={styles.tituloazulleyenda}>
                                    {/* {item.leyenda} */}
                                  </span>{" "}
                                  <span className={styles.tituloazul2}>
                                    ${item.precio}
                                  </span>
                                </>
                              );
                              return td;
                              break;
                            } else {
                              let promo = false;
                            }
                          }

                          if (!promo) {
                            td.push(
                              <>
                                <span className={styles.tituloazul2}>
                                  ${itemCanal.precio}
                                </span>
                                <span className={styles.tituloazul3}>/mes</span>
                              </>
                            );
                            return td;
                          }
                        })()}
                      </Card.Text>
                      {/* Boton OTT Nueva Funcionalidad*/}
                      {formatoOTT(itemCanal) ? (
                        <Button
                          variant="primary"
                          className={styles.botonazul}
                          onClick={() => {
                            setSelectedChannel(itemCanal);
                            setShowModal(true);
                            enviarOTT(itemCanal);
                            setNombreOTTCRM(itemCanal.nombreProductoCRM);
                            setNombreOTT(itemCanal.nombre);
                          }}
                        >
                          Contratar
                        </Button>
                      ) : (
                        <Button
                          variant="primary"
                          className={styles.botonazul}
                          onClick={() => {
                            indice2(index);
                            muestra2(false);
                            origen2(nombreorigen);
                          }}
                        >
                          Contratar
                        </Button>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          ) : (
            <Row>
              {arrayCanal2.map((itemCanal: Canal, index: number) => (
                <Col key={index} style={{ padding: "0em 0em 2em 0em" }}>
                  <Card
                    style={{ width: "18rem", padding: "20px 15px 10px 15px" }}
                  >
                    <img
                      src={getImages(itemCanal.nombre, itemCanal.imagen)}
                      className={styles.imagen}
                    />
                    <Card.Body className={styles.cardBody}>
                      <Card.Title className={styles.tituloazul}>
                        {itemCanal.nombre}
                      </Card.Title>
                      <Card.Text className={styles.price}>
                        {(() => {
                          let td = [];
                          let promo = false;
                          for (let i = 0; i < precios.length; i++) {
                            let item = precios[i];

                            if (
                              item.titulo === itemCanal.nombre &&
                              item.titulo
                            ) {
                              promo = true;
                              td.push(
                                <>
                                  <span className={styles.tituloazulleyenda}>
                                    {item.leyenda}
                                  </span>{" "}
                                  <span className={styles.tituloazulprecio}>
                                    ${itemCanal.precio} /mes
                                  </span>
                                </>
                              );
                              return td;
                              break;
                            } else {
                              let promo = false;
                            }
                          }

                          if (!promo) {
                            td.push(
                              <>
                                {" "}
                                <span style={{ color: "white" }}> ... </span>
                              </>
                            );
                            return td;
                          }
                        })()}
                      </Card.Text>
                      <Card.Text className={styles.price}>
                        {(() => {
                          let td = [];
                          let promo = false;
                          for (let i = 0; i < precios.length; i++) {
                            let item = precios[i];

                            if (
                              item.titulo === itemCanal.nombre &&
                              item.titulo
                            ) {
                              promo = true;
                              td.push(
                                <>
                                  <span className={styles.tituloazulleyenda}>
                                    {item.leyenda}
                                  </span>{" "}
                                  <span className={styles.tituloazul2}>
                                    ${item.precio}
                                  </span>
                                </>
                              );
                              return td;
                              break;
                            } else {
                              let promo = false;
                            }
                          }

                          if (!promo) {
                            td.push(
                              <>
                                <span className={styles.tituloazul2}>
                                  ${itemCanal.precio} /mes
                                </span>
                                <span className={styles.tituloazul3}>/mes</span>
                              </>
                            );
                            return td;
                          }
                        })()}
                      </Card.Text>

                      {formatoOTT(itemCanal) ? (
                        <Button
                          variant="primary"
                          className={styles.botonazul}
                          onClick={() => {
                            setSelectedChannel(itemCanal);
                            setShowModal(true);
                            enviarOTT(itemCanal);
                            setNombreOTTCRM(itemCanal.nombreProductoCRM);
                            setNombreOTT(itemCanal.nombre);
                          }}
                        >
                          Contratar
                        </Button>
                      ) : (
                        <Button
                          variant="primary"
                          className={styles.botonazul}
                          onClick={() => {
                            indice2(index);
                            muestra2(false);
                            origen2(nombreorigen);
                          }}
                        >
                          Contratar
                        </Button>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          )}
        </Container>
      </div>

      <div id="small" className="d-lg-none d-xl-none">
        {
          <Container>
            <div className={styles["confirmMessage"]}>
              <ConfirmMessage
                status={status}
                message={message}
                showAlert={showAlert}
              />
            </div>
            <Row className={styles["rowcolapsible"]}>
              <hr className={styles["hrstyle"]} />
              <Col>
                <p
                  style={{ marginBottom: "1vw" }}
                  className={styles.peliculasSmall}
                >
                  {nombreorigen == "aplicaciones"
                    ? "Aplicaciones"
                    : nombreorigen == "adultos"
                      ? "Adultos"
                      : ""}
                </p>
              </Col>
              <Col>
                <div className={styles.alineaFlecha}>
                  <img
                    src={flecha}
                    aria-controls="example-collapse-text"
                    aria-expanded={collapse}
                    className={
                      collapse === true ? styles["rota"] : styles["noRota"]
                    }
                    onClick={muestraCollapse}
                  />
                </div>
              </Col>
              <hr className={styles["hrstyle"]} />
            </Row>
            <Modal show={showModal} onHide={handleClose} centered>
              <Loading isLoading={loading} />
              <Modal.Body className={styles.modalBody}>
                <p className={styles.description}>
                  Hemos enviado un código al <b>número {phone}</b> y al{" "}
                  <b>{mail}</b>
                </p>

                <p className={styles.subText}>Ingresa código de verificación</p>

                <Form className={styles.form}>
                  <div className={styles.codeInputContainer}>
                    <input
                      key={"index1"}
                      id="inputuno"
                      type="text"
                      maxLength={1}
                      value={numUno}
                      onChange={(e) => handleChange2(1, e.target.value)}
                      className={styles.codeInput}
                    />
                    <input
                      key={"index2"}
                      id="inputdos"
                      type="text"
                      maxLength={1}
                      value={numDos}
                      onChange={(e) => handleChange2(2, e.target.value)}
                      className={styles.codeInput}
                    />
                    <input
                      key={"index3"}
                      id="inputtres"
                      type="text"
                      maxLength={1}
                      value={numTres}
                      onChange={(e) => handleChange2(3, e.target.value)}
                      className={styles.codeInput}
                    />
                    <input
                      key={"index4"}
                      id="inputcuatro"
                      type="text"
                      maxLength={1}
                      value={numCuatro}
                      onChange={(e) => handleChange2(4, e.target.value)}
                      className={styles.codeInput}
                    />
                  </div>
                </Form>

                <Button
                  className={styles.validateButton}
                  onClick={verificarOTT}
                >
                  Validar cuenta
                </Button>

                <p className={styles.resendText}>
                  ¿No recibiste el código?{" "}
                  <a className={styles.resendLink} onClick={reenviarOTT}>
                    Reenviar
                  </a>
                </p>
              </Modal.Body>
            </Modal>

            <Modal
              show={showErrorModal}
              onHide={() => setShowErrorModal(false)}
              centered
            >
              <Modal.Body className={styles.modalBody}>
                <div className={styles.iconContainer}>
                  {/* <BsX /> */}
                  <svg
                    width="60"
                    height="60"
                    viewBox="0 0 125 125"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M62.5 15.4165C36.4966 15.4165 15.4166 36.4964 15.4166 62.4998C15.4166 88.5033 36.4966 109.583 62.5 109.583C88.5034 109.583 109.583 88.5033 109.583 62.4998C109.583 36.4964 88.5034 15.4165 62.5 15.4165ZM5.41663 62.4998C5.41663 30.9736 30.9737 5.4165 62.5 5.4165C94.0262 5.4165 119.583 30.9736 119.583 62.4998C119.583 94.0261 94.0262 119.583 62.5 119.583C30.9737 119.583 5.41663 94.0261 5.41663 62.4998ZM81.6605 43.3393C83.6131 45.2919 83.6131 48.4577 81.6605 50.4104L69.571 62.4998L81.6605 74.5893C83.6131 76.5419 83.6131 79.7077 81.6605 81.6604C79.7079 83.613 76.542 83.613 74.5894 81.6604L62.5 69.5709L50.4105 81.6604C48.4579 83.613 45.292 83.613 43.3394 81.6604C41.3868 79.7077 41.3868 76.5419 43.3394 74.5893L55.4289 62.4998L43.3394 50.4104C41.3868 48.4577 41.3868 45.2919 43.3394 43.3393C45.292 41.3867 48.4579 41.3867 50.4105 43.3393L62.5 55.4288L74.5894 43.3393C76.542 41.3867 79.7079 41.3867 81.6605 43.3393Z"
                      fill="#E62443"
                    />
                  </svg>
                </div>
                <h3 className={styles.title}>Código incorrecto</h3>
                <p className={styles.description}>
                  El código de verificación es incorrecto, intenta una vez más
                  para continuar el proceso.
                </p>

                <Button
                  className={styles.validateButton}
                  onClick={() => {
                    setShowModal(true);
                    setShowErrorModal(false);
                    setNumUno("");
                    setNumDos("");
                    setNumTres("");
                    setNumCuatro("");
                  }}
                >
                  Intentar de nuevo
                </Button>
              </Modal.Body>
            </Modal>

            {arrayCanal2.map((itemCanal: Canal, index: number) => (
              <Collapse in={collapse} key={index}>
                <Row>
                  <Col>
                    <Card
                      className={styles.cardImgSmall}
                      //onClick={() => handleShow(index)}
                    >
                      <Row>
                        <Col xs={4} className={styles.contenedorImgSmall}>
                          <div>
                            <Card.Img
                              src={getImages(
                                itemCanal.nombre,
                                itemCanal.imagen
                              )}
                              className={styles.imgSmall}
                              onClick={() => {
                                if (formatoOTT(itemCanal)) {
                                  setSelectedChannel(itemCanal);
                                  setShowModal(true);
                                  enviarOTT(itemCanal);
                                  setNombreOTTCRM(itemCanal.nombreProductoCRM);
                                  setNombreOTT(itemCanal.nombre);
                                } else {
                                  indice2(index);
                                  muestra2(false);
                                  origen2(nombreorigen);
                                }
                              }}
                            />
                          </div>
                        </Col>
                        <Col xs={8} className={styles.contenedorItemSmall}>
                          <Card.Text className={styles.info}>
                            <p className={styles.precioCard}>
                              <b>{itemCanal.nombre.slice(0, 20)}</b>
                            </p>
                            {(() => {
                              let td = [];
                              let promo = false;
                              for (let i = 0; i < precios.length; i++) {
                                let item = precios[i];

                                if (
                                  item.titulo === itemCanal.nombre &&
                                  item.titulo
                                ) {
                                  promo = true;
                                  td.push(
                                    <>
                                      <p className={styles.tituloazulprecio}>
                                        ${itemCanal.precio} / mes
                                      </p>
                                    </>
                                  );
                                  return td;
                                  break;
                                } else {
                                  let promo = false;
                                }
                              }

                              if (!promo) {
                                td.push(
                                  <>
                                    <p className={styles.ptituloazulprecio}>
                                      <span
                                        className={styles.tituloazulleyenda}
                                      >
                                        {""} &nbsp;
                                      </span>
                                      <span className={styles.allday}>
                                        {""}
                                      </span>
                                    </p>
                                  </>
                                );
                                return td;
                              }
                            })()}

                            {(() => {
                              let td = [];
                              let promo = false;
                              for (let i = 0; i < precios.length; i++) {
                                let item = precios[i];

                                if (
                                  item.titulo === itemCanal.nombre &&
                                  item.titulo
                                ) {
                                  promo = true;
                                  td.push(
                                    <>
                                      <p className={styles.ptituloazulprecio}>
                                        <span
                                          className={styles.tituloazulleyenda}
                                        >
                                          {item.leyenda} &nbsp;
                                        </span>
                                        <span className={styles.allday}>
                                          ${item.precio}
                                        </span>
                                      </p>
                                    </>
                                  );
                                  return td;
                                  break;
                                } else {
                                  let promo = false;
                                }
                              }

                              if (!promo) {
                                td.push(
                                  <>
                                    <p className={styles.ptituloazulprecio}>
                                      <span
                                        className={styles.tituloazulleyenda}
                                      >
                                        {""} &nbsp;
                                      </span>
                                      <span className={styles.allday}>
                                        ${itemCanal.precio} / mes
                                      </span>
                                    </p>
                                  </>
                                );
                                return td;
                              }
                            })()}
                          </Card.Text>
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                </Row>
              </Collapse>
            ))}
          </Container>
        }
      </div>
    </>
  );
};

export default CanalesCarta;
